// Quiz.tsx
import React, { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import DnevnaNagrada from "./DnevnaNagrada";
import checkQuizStatus from "../helpers/checkQuizStatus";

export interface QuizProps {
  email: string;
  code: string;
}

const Quiz: React.FC = () => {
  const location = useLocation().state as QuizProps;
  const navigate = useNavigate();
  
  const [isQuizActive, setIsQuizActive] = useState<boolean | null>(null);
  const [isCheckingStatus, setIsCheckingStatus] = useState(true);

  // Provera da li je kviz aktivan
  useEffect(() => {
    checkStatus();
  }, []);

  const checkStatus = async () => {
    setIsCheckingStatus(true);
    const status = await checkQuizStatus();
    setIsQuizActive(status.isActive); // Uzmi samo isActive iz response objekta
    setIsCheckingStatus(false);
  };

  // Redirect u useEffect ako nema podataka ili kviz nije aktivan
  useEffect(() => {
    if (!location || !location.email || !location.code) {
      navigate("/");
      return;
    }

    if (isQuizActive === false) {
      navigate("/");
    }
  }, [location, navigate, isQuizActive]);

  // Loading state
  if (isCheckingStatus) {
    return (
      <div className="quiz-loading">
        <h2>Učitavanje kviza...</h2>
        <p>Molimo vas sačekajte.</p>
      </div>
    );
  }

  // Early return dok se ne preusmeri
  if (!location || !location.email || !location.code || isQuizActive === false) {
    return null;
  }

  const { email, code } = location;

  // Direktno renderujemo DnevnaNagrada komponentu
  return (
    <div className="quiz">
      <DnevnaNagrada email={email} code={code} />
    </div>
  );
};

export default Quiz;
